"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersServiceDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.MembersServiceDefinition = (0, services_definitions_1.defineService)('viewer-core/members');
//# sourceMappingURL=index.js.map